import React, { useState } from "react";
import "../styles/ProductBrief.css";
import urlBackEnd from "../services/authServices";

function ProductBrief({ product, handleClose }) {
  const [editMode, setEditMode] = useState(false);
  const [editedProduct, setEditedProduct] = useState({ ...product });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setEditedProduct((prevState) => ({
      ...prevState,
      [name]: newValue
    }));
  };

  const updateProduct = async () => {
    try {
      const response = await fetch(`${urlBackEnd.servUrl}/edit/:property'`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: product._id,
          updatedProduct: editedProduct
        })
      });

      if (response.ok) {
        const data = await response.json();
        // Handle the response or any additional logic
        console.log(data);
      } else {
        throw new Error('Failed to update product');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSaveClick = () => {
    // Perform save operation with editedProduct
    updateProduct();
    setEditMode(false);
  };

  const handleCancelClick = () => {
    setEditMode(false);
    setEditedProduct({ ...product });
  };

  const renderProperty = (property) => {
    if (editMode) {
      return (
        <input
          type={property.type || "text"}
          name={property.name}
          value={editedProduct[property.name]}
          onChange={handleInputChange}
        />
      );
    } else if (property.type === "checkbox") {
      return <span>{editedProduct[property.name] ? "Yes" : "No"}</span>;
    } else {
      return <span>{editedProduct[property.name]}</span>;
    }
  };

  return (
    <div className="product-card">
      <h3>Detalles de Producto</h3>
      {Object.keys(product).map((propertyName) => (
        <div key={propertyName}>
          <label htmlFor={propertyName}>{propertyName}:</label>
          {renderProperty({
            name: propertyName,
            type: typeof product[propertyName] === "boolean" ? "checkbox" : "text"
          })}
        </div>
      ))}
      <div>
        {editMode ? (
          <button className="btn-save" onClick={handleSaveClick}>Save</button>
        ) : (
          <button className="btn-edit" onClick={() => setEditMode(true)}>Edit</button>
        )}
        <button className="btn-cancel" onClick={handleCancelClick}>Cancel</button>
        <button className="btn-close" onClick={handleClose}>Close</button>
      </div>
    </div>
  );
}

export default ProductBrief;
